import React from 'react';
import { Filter } from 'lucide-react';

const AnalyticsFilters = ({ filters, onFilterChange }) => {
  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
      <div className="flex items-center gap-2 mb-4">
        <Filter className="w-5 h-5 text-gray-600" />
        <h3 className="font-semibold text-gray-900">Analytics Filters</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Timeframe */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Timeframe</label>
          <select
            value={filters?.timeframe}
            onChange={(e) => handleFilterChange('timeframe', e?.target?.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="30days">Last 30 Days</option>
            <option value="90days">Last 90 Days</option>
            <option value="6months">Last 6 Months</option>
            <option value="1year">Last Year</option>
            <option value="all">All Time</option>
          </select>
        </div>

        {/* Severity Threshold */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Min Severity: {filters?.severityThreshold}
          </label>
          <input
            type="range"
            min="1"
            max="10"
            value={filters?.severityThreshold}
            onChange={(e) => handleFilterChange('severityThreshold', parseInt(e?.target?.value))}
            className="w-full"
          />
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>1</span>
            <span>10</span>
          </div>
        </div>

        {/* Include Weather */}
        <div className="flex items-center">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={filters?.includeWeather}
              onChange={(e) => handleFilterChange('includeWeather', e?.target?.checked)}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm font-medium text-gray-700">Include Weather Data</span>
          </label>
        </div>

        {/* Include Medication */}
        <div className="flex items-center">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              checked={filters?.includeMedication}
              onChange={(e) => handleFilterChange('includeMedication', e?.target?.checked)}
              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="text-sm font-medium text-gray-700">Include Medication Data</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsFilters;